import { Div, Flex, Text } from "@hopper-ui/components";
import { ConversationHistoryCategoryItem } from "@/features/conversations/components/conversation-history/ConversationHistoryCategoryItem.tsx";
import type { Conversation } from "@workleap-ai/shared/types";

interface Props {
    title: string;
    conversations: Conversation[];
}

export const ConversationHistoryCategory = ({ title, conversations }: Props) => {
    if (conversations.length === 0) {
        return null;
    }

    return (
        <Div width="100%">
            <Div
                paddingX="inset-sm"
                paddingBottom="inset-sm"
            >
                <Text
                    fontFamily="overline"
                    fontSize="overline"
                    fontWeight="overline"
                    textTransform="uppercase"
                    color="neutral-weak"
                >
                    {title}
                </Text>
            </Div>
            <Flex
                direction="column"
                gap="inline-xs"
            >
                {conversations.map(conversation => (
                    <ConversationHistoryCategoryItem key={conversation.conversationId} conversation={conversation} />
                ))}
            </Flex>
        </Div>
    );
};
